import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'Legacy',
    name: 'Z-Ostrzy-Zrodzony',
    id: 'Bladius',
    health: 40,
    difficulty: 1,
    expeditionRating: 1,
    additionalInfo: '',
  },
  {
    expansion: 'Legacy',
    name: 'Martwomyśl',
    id: 'Deathmind',
    health: 80,
    difficulty: 6,
    expeditionRating: 4,
    additionalInfo: '',
  },
  {
    expansion: 'Legacy',
    name: 'Pylak Amoku',
    id: 'FungalMesh',
    health: 70,
    difficulty: 4,
    expeditionRating: 2,
    additionalInfo: '',
  },
  {
    expansion: 'Legacy',
    name: 'Odrodzone Wszechostrze',
    id: 'MaelstromRisen',
    health: 65,
    difficulty: 8,
    expeditionRating: 4,
    additionalInfo: `
        <p>
          Podczas przygotowania, odejmij dwie podstawowe karty Nemezis każdego poziomu.
        </p>
      `,
  },
  {
    expansion: 'Legacy',
    name: 'Patriarcha Kopca',
    id: 'SpawningHorror',
    health: 50,
    difficulty: 3,
    expeditionRating: 1,
    additionalInfo: '',
  },
  {
    expansion: 'Legacy',
    name: 'Xaxos Przemieniony',
    id: 'XaxosAscended',
    health: 90,
    difficulty: 9,
    expeditionRating: 4,
    additionalInfo: `
        <p>
          Podczas przygotowania, odejmij trzy podstawowe karty Nemezis każdego poziomu.
        </p>
      `,
  },
]
